module.exports = __webpack_public_path__ + "static/media/transportecarga.244f04cc.png";